import { writable } from "svelte/store";
import * as api from "../apis/rcpMng.api";

export async function apiGetRcpMng(order_no) {
    try {
        const response = await api.apiGetRcpMng(order_no);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetRcpMngDetail() {
    try {
        const response = await api.apiGetRcpMngDetail();

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiPostRcpMng(order_no, wrhousng_de, barcodeList) {
    try {
        let formData = {
            order_no: order_no,
            wrhousng_de: wrhousng_de,
            barcodeList: barcodeList,
        };

        const response = await api.apiPostRcpMng(formData);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetRcpList(sdate, edate) {
    try {
        const response = await api.apiGetRcpList(sdate, edate);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}
